import { combineReducers } from "redux";
import auth from "./auth";
import company from "./company";
import user from "./user";
import project from "./project";
import assignAccess from "./assignAccess";
import userManagement from "./userManagement";
import assets from "./assets";
import plan from "./plan";
import dataaudit from "./dataAudit";
import process from "./process";
import analyse from "./analyse";
import reports from "./reports";
import assetjson from "./assetJson";
import defaultConfig from "./defaultConfig";
import language from "./language";

export default combineReducers({
  auth,
  company,
  user,
  project,
  assignAccess,
  userManagement,
  assets,
  plan,
  dataaudit,
  process,
  analyse,
  reports,
  assetjson,
  defaultConfig,
  language,
});
